<template>
    <Popup ref="popup" :animation="'scale'">
        <div :class="getContainerClass()" :style="{ ...containerStyle, transform: landscapeScale < 1 ? `scale(${landscapeScale})` : 'none' }">
            <img class="close-btn" :src="_global.assetsRoot + '/common/pop_btn_close.png'" @click.stop="hide">
            <img class="title-img" :src="getTitleImage()" />
            <div class="airdrop-title">
                <span :class="['title-text', 'beba', `title-text--${getCurrentLang()}`]">{{ $t("message.openAppTitle") }}</span>
            </div>
            <img class="airdrop-icon" :src="_global.assetsRoot + '/common/pop_icon_openapp.png'" />
            <div class="collect-btn" @click.stop="collectAirShop()">
                <span class="btn-text beba">{{ $t("message.openTheApp") }}</span>
            </div>
        </div>
    </Popup>
</template>

<script>
import api from '../../network/api';
import Popup from '../Popup.vue';
export default {
    props: {
        userID: String
    },
    data() {
        return {
            landscapeScale: 1
        }
    },
    computed: {
        containerStyle() {
            let backgroundImage = this._global.isMobile ? `url(${this._global.assetsRoot}/mobile/pop_airdrop_bg.png)` : `url(${this._global.assetsRoot}/desktop/pop_airdrop_bg.png)`;
            return {
                 backgroundImage: backgroundImage
            };
        }
    },
    methods: {
        show() { 
            if (window.innerWidth > window.innerHeight) {
                this.landscapeScale = Math.min((window.innerHeight * 0.75) / (window.innerWidth * 0.85), 1);
            } else {
                this.landscapeScale = 1;
            }
            this.$refs.popup.show() 
        },
        hide() { this.$refs.popup.hide() },
        collectAirShop() {
            //window.vthis && window.vthis.wakeupApp && window.vthis.wakeupApp();
            /*api.collectAirShop(this.userID).then((resp) => {
                this.$emit('airdrop-collected-coins', resp);
                this.$emit('open-redeem');
                this.hide();
            });*/
            this.hide();
        },
        getContainerClass(){
            return 'airdrop-container';
        },
        getTitleImage() {
            let userLanguage = this._global.user.lang || 'en';
            const langMap = {
                'pt': 'pt',
                'es': 'es',
                'en': 'en'
            };
            const lang = langMap[userLanguage] || 'en';
            return this._global.assetsRoot + `/common/pop_openapp_title_${lang}.png`;
        },
        getCurrentLang() {
            let userLanguage = (this._global.user && this._global.user.lang) || 'en';
            const baseLang = String(userLanguage).toLowerCase().split('-')[0];
            return ['pt', 'es', 'en'].includes(baseLang) ? baseLang : 'en';
        },
    },
    components: {
        Popup,
    }
}
</script>

<style lang="scss" scoped>
@import "../../assets/css/variables.scss";

.airdrop-container {
    background-size: 100% 100%;
    background-repeat: no-repeat;
    background-position: center;
    width: 100vw;
    height: 80vw;
    aspect-ratio: 1;
    margin: 0 auto;
    box-sizing: border-box;
    position: relative;
    transform-origin: center center;

    .close-btn {
        width: 10vw;
        height: 10vw;
        position: absolute;
        top: -3vw;
        right: 0;
        cursor: pointer;
        z-index: 10;
    }

    .title-img {
        width: 100%;
        position: absolute;
        top: -3.5vw;
        left: 0;
        scale: 0.7;
        z-index: 5;
    }

    .airdrop-icon {
        position: absolute;
        top: 20vw;
        left: 50%;
        transform: translateX(-50%);
        width: 25vw;
        height: auto;
        z-index: 5;
    }

    .collect-btn {
        position: absolute;
        top: 65vw;
        left: 50%;
        transform: translateX(-50%);
        width: 45vw;
        height: 12vw;
        background: url($assetRoot + "/common/btn_logout_stay.png") center no-repeat;
        background-size: 100% 100%;
        cursor: pointer;
        z-index: 5;
        display: flex;
        align-items: center;
        justify-content: center;

        .btn-text {
            color: #FFFFFF;
            font-size: 7vw;
            font-weight: bold;
            text-shadow:
                -1px -1px 0 #000000,
                0px -1px 0 #000000,
                1px -1px 0 #000000,
                -1px  0px 0 #000000,
                1px  0px 0 #000000,
                -1px  1px 0 #000000,
                0px  1px 0 #000000,
                1px  1px 0 #000000;
        }
    }

    .airdrop-title {
        position: absolute;
        top: 15vw;
        left: 0;
        right: 0;
        text-align: center;
        z-index: 5;
        padding: 0 9vw;
        box-sizing: border-box;

        .title-text {
            display: block;
            color: #FFFFFF;
            font-size: 5vw;
            font-weight: bold;
            line-height: 1.02;
            white-space: normal;
            word-break: break-word;
            text-shadow:
                -2px -2px 0 #2641bf,
                0px -2px 0 #2641bf,
                2px -2px 0 #2641bf,
                -2px  0px 0 #2641bf,
                2px  0px 0 #2641bf,
                -2px  2px 0 #2641bf,
                0px  2px 0 #2641bf,
                2px  2px 0 #2641bf;
        }

        .title-text--pt,
        .title-text--es {
            font-size: 4.2vw;
            line-height: 1;
        }
    }
}

.mobile{
    .airdrop-container {
        background-size: 100% 100%;
        width: 80vw;
        height: unset;
    }

    .title-img {
        top: 0;
    }

    .airdrop-title {
        top: 16vw;
    }

    .airdrop-icon {
        top: 20vw;
    }

    .collect-btn {
        top: 65vw;
        width: 40vw;
        height: 12vw;
    }
}
</style>



// WEBPACK FOOTER //
// src/components/popup/OpenApp.vue